$.fn.avTooltip = function() {
  $(this).tooltip({
    html: true,
    title: function() {
      var tooltip = $(this);
      var contentId = tooltip.data('tooltipContentId');

      return contentId ? $('[id=' + contentId + ']').html() : '';
    }
  }).click(function() {
    $(this).tooltip('show');
    return false;
  }).on('show.bs.tooltip', function() {
    $(this).addClass('active');
  }).on('hide.bs.tooltip', function() {
    $(this).removeClass('active');
  }).on('show', function (e) {
    if ('ontouchstart' in document.documentElement) {
      e.preventDefault()
    }
  });

  return this;
};